import rest from "@/rest-client";

/**
 * TKP-200 m.7 / m.13 — + panelinden kütüphanede ve organizasyon sözlüğünde olmayan kayıt açılır (veri, veri kaynağı, ilgili kişi).
 * Sözlük kaydı doğrudan açılır (katalog; onay kapsamı dışında), düğüm/satır eklemesi her zamanki gibi (onay açıksa taslak).
 * `process` yetki bağlamıdır: süreç yöneticisi kendi sürecinde açabilir. TKP-236 n.3: gölge (taslak) süreçte gerçek kimlik yok — yerine
 * sürecin birimi gider (birim yetkilisi açabilir; eskiden bağlam hiç gitmiyor, Birim/Süreç Yöneticisi 403 alıyordu). `category` organizasyon
 * kategorisi (tam nesne, `libraryItem` ile eşleşir) — veri ve ilgili kişi için zorunlu.
 */
/** Yetki bağlamı: gerçek süreç kimliği, gölge süreçte sürecin birimi. */
export const authorityContext = (process) => {
  if (process && process._id && !process.__draft) return { process: { _id: String(process._id) } };
  const department = process && process.__draft && process.department && (process.department._id || process.department);
  return department ? { department: { _id: String(department) } } : {};
};

export const createDictionaryEntry = async (path, text, { category, process, language = "tr" } = {}) => {
  const ctx = authorityContext(process);
  const response = await rest.post(path, { item: { name: { [language || "tr"]: text }, ...(category ? { category } : {}) }, ...ctx });
  return response && response.data;
};
